// extracted by mini-css-extract-plugin
export default {"btnpwd":"_3544d8e242"};